import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TreeSelectModule } from 'primeng/treeselect';
import { InputMaskModule } from 'primeng/inputmask';
import { MultiSelectModule } from 'primeng/multiselect';
import { PasswordModule } from 'primeng/password';
import { InputNumberModule } from 'primeng/inputnumber';
import { Toast } from 'primeng/toast'; 
import { SelectModule } from 'primeng/select'; 
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ListboxModule } from 'primeng/listbox';
import { AccordionModule } from 'primeng/accordion';
import { CardModule } from 'primeng/card';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';

// PrimeNG Services
import { ConfirmationService, FilterService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    Toast
  ],
  exports: [
    SelectModule, 
    TreeSelectModule,
    InputMaskModule,
    MultiSelectModule,
    PasswordModule,
    InputNumberModule,
    Toast, 
    ButtonModule,
    CheckboxModule,
    ListboxModule,
    AccordionModule,
    CardModule,
    MenuModule,
    TooltipModule,
  ],
  providers: [],
})
export class PrimengModule {}
